import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "format-italic",
  "use": "format-italic-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"format-italic\"><path fill-rule=\"evenodd\" d=\"M10 5v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol